<template>
  <div class="auth-check-inbox">
    <h1
      class="auth-check-inbox__title"
      v-html="$t('auth.checkInbox.title')"
    ></h1>

    <p class="auth-check-inbox__text"><slot /></p>

    <PrimaryButton
      class="auth-check-inbox__button"
      @click.prevent="$emit('close')"
    >
      {{ $t("auth.checkInbox.closeBtn") }}
    </PrimaryButton>
  </div>
</template>

<script>
import { PrimaryButton } from "@v2/shared/ui/components";

export default {
  name: "AuthCheckInbox",
  components: { PrimaryButton }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.auth-check-inbox {
  padding: 48px 80px 64px 80px;
  width: 460px;
  box-sizing: border-box;

  @include respond-down(md) {
    width: calc(100vw - 16 * 2px);
    max-width: 340px;
    flex-grow: 1;

    padding: 24px;
  }

  &__title {
    @include h1();
    margin: 0 0 25px 0;

    @include respond-down(md) {
      font-size: 24px;
      margin-bottom: 12px;

      br {
        display: none;
      }
    }
  }

  &__text {
    font-size: 13px;
    line-height: 1.54;
    color: #6d7179;
  }

  &__button {
    margin-top: 30px;
    padding-left: 46.5px;
    padding-right: 46.5px;

    @include respond-down(md) {
      margin-top: 24px;
    }
  }
}
</style>
